import {
  Dialog,
  DialogContent,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Box,
  LinearProgress,
  Typography,
} from "../../../../components";

const SincronizacaoInicialDialog = ({ open, tempoRestante }) => {
  const formatarTempo = (segundos) => {
    const minutos = Math.floor(segundos / 60);
    const segs = segundos % 60;
    return `${minutos.toString().padStart(2, "0")}:${segs.toString().padStart(2, "0")}`;
  };

  const calcularProgresso = () => {
    return ((120 - tempoRestante) / 120) * 100;
  };

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="sm"
      PaperComponent="div"
      open={open}
      aria-labelledby="sincronizacao-inicial-dialog"
    >
      <DialogContent>
        <Card className="p-3">
          <CardHeader title="Instalando PDV Offline" />
          <CardContent className="p-3">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box className="text-center mb-3">
                  <Typography variant="body1" className="mb-2">
                    Estamos preparando o sistema para funcionar offline.
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Aguarde enquanto sincronizamos os dados necessários...
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12}>
                <Box className="mb-2">
                  <Typography variant="h6" className="text-center mb-2">
                    Tempo restante: {formatarTempo(tempoRestante)}
                  </Typography>
                </Box>
                <LinearProgress 
                  variant="determinate" 
                  value={calcularProgresso()} 
                  style={{ height: 10, borderRadius: 5 }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box className="text-center mt-2">
                  <Typography variant="caption" color="textSecondary">
                    Por favor, não feche esta janela durante a instalação.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default SincronizacaoInicialDialog;
